/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface SMSearchFormValidationData
 */
export interface SMSearchFormValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SMSearchFormValidationData
     */
    description?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SMSearchFormValidationData
     */
    maxPriceSolutions?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SMSearchFormValidationData
     */
    maxPricePoints?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SMSearchFormValidationData
     */
    carriers?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SMSearchFormValidationData
     */
    fareTypes?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SMSearchFormValidationData
     */
    accountCode?: ValidationMessage;
}

export function SMSearchFormValidationDataFromJSON(json: any): SMSearchFormValidationData {
    return SMSearchFormValidationDataFromJSONTyped(json, false);
}

export function SMSearchFormValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SMSearchFormValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : ValidationMessageFromJSON(json['description']),
        'maxPriceSolutions': !exists(json, 'maxPriceSolutions') ? undefined : ValidationMessageFromJSON(json['maxPriceSolutions']),
        'maxPricePoints': !exists(json, 'maxPricePoints') ? undefined : ValidationMessageFromJSON(json['maxPricePoints']),
        'carriers': !exists(json, 'carriers') ? undefined : ValidationMessageFromJSON(json['carriers']),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : ValidationMessageFromJSON(json['fareTypes']),
        'accountCode': !exists(json, 'accountCode') ? undefined : ValidationMessageFromJSON(json['accountCode']),
    };
}

export function SMSearchFormValidationDataToJSON(value?: SMSearchFormValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': ValidationMessageToJSON(value.description),
        'maxPriceSolutions': ValidationMessageToJSON(value.maxPriceSolutions),
        'maxPricePoints': ValidationMessageToJSON(value.maxPricePoints),
        'carriers': ValidationMessageToJSON(value.carriers),
        'fareTypes': ValidationMessageToJSON(value.fareTypes),
        'accountCode': ValidationMessageToJSON(value.accountCode),
    };
}


